<div class="cluster-details-container">
  <div class="cluster-details-header">
    <button class="back-button" (click)="close()">
      <mat-icon>arrow_back_ios</mat-icon>
    </button>
    <h2 class="header-title">Probabilidad de lugares</h2>
  </div>

  <div class="cluster-details-content">
    <p class="description">Día y hora con más probabilidad de encontrar un auto en esta área</p>

    <div class="info-section">
      <div class="info-row">
        <span class="identifier-label">{{ data.identifier }}</span>
      </div>
      <div class="info-row">
        <span class="description-label">{{ data.description }}</span>
      </div>
    </div>

    <div class="stats-section">
      <div class="stats-column">
        <div class="stat-row">
          <span class="stat-label">Fecha:</span>
          <span class="stat-value">{{ mostSignificantDay }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Hora:</span>
          <span class="stat-value">{{ mostSignificantHour }}:00</span>
        </div>
      </div>

      <div class="stats-column">
        <div class="percentage-box" [style.background-color]="data.color">
          <span class="percentage-value">{{ data.percentage }}%</span>
        </div>
      </div>
    </div>

    <div class="heatmap-section">
      <!-- <h3 class="heatmap-title">Mapa de Calor - Frecuencia por Día y Hora</h3> -->
      <div class="heatmap-container">
        <!-- <canvas baseChart
                [data]="heatMapData"
                [type]="'matrix'"
                [options]="heatMapOptions">
        </canvas> -->
        <canvas id="matrixChart"></canvas>
      </div>
    </div>
  </div>
</div>
